import { Optional } from '@rygen/rygen-ui/model';

import i18n from '@/i18n';

import { ShipmentStopType } from '../shipment/ShipmentStopType';

export type StopSelector =
  'origin' | 'intermediate' | 'destination' | 'crossdock';

export const TRANSLATIONS_BY_STOP_SELECTOR: Record<StopSelector, string> = {
  origin: i18n.global.t('orders.origin'),
  destination: i18n.global.t('orders.destination'),
  intermediate: i18n.global.t('shipments.stops'),
  crossdock: i18n.global.t('shipments.crossdocks'),
};

export const SHIPMENT_STOP_TYPES_BY_STOP_SELECTOR: Record<
  StopSelector,
  Optional<ShipmentStopType>
> = {
  origin: ShipmentStopType.PICKUP,
  intermediate: undefined,
  destination: ShipmentStopType.DROP_OFF,
  crossdock: ShipmentStopType.UNKNOWN, // crossdocks will be split into separate pickup and dropoff stops
};
